export default "__VITE_ASSET__egwKxt64__"